import { useFormikContext } from "formik";
import { useEffect } from "react";

const FocusError = () => {
  const { errors, isSubmitting, isValidating, setFieldError } =
    useFormikContext();

  useEffect(() => {
    if (isSubmitting && !isValidating) {
      const errorFields = getNestedErrorFields(errors);

      if (errorFields.length > 0) {
        const firstErrorField = errorFields[0];
        const errorElement = document.getElementById(firstErrorField);
        if (errorElement) {
          scrollIntoView(errorElement);
        }
      }
    }
  }, [errors, isSubmitting, isValidating, setFieldError]);

  const getNestedErrorFields = (errors, path = "") => {
    let errorFields = [];
    if (errors && typeof errors === "object") {
      Object.keys(errors)?.forEach((field) => {
        if (!field) return;
        const currentPath = path ? `${path}.${field}` : field;

        if (Array.isArray(errors[field])) {
          errors[field].forEach((item, index) => {
            errorFields = [
              ...errorFields,
              ...getNestedErrorFields(item, `${currentPath}[${index}]`),
            ];
          });
        } else if (
          typeof errors[field] === "object" &&
          errors[field] !== null
        ) {
          errorFields = [
            ...errorFields,
            ...getNestedErrorFields(errors[field], currentPath),
          ];
        } else {
          errorFields.push(currentPath);
        }
      });
    }

    return errorFields;
  };

  const scrollIntoView = (element) => {
    element?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return null;
};

export default FocusError;
